if (!customElements.get('lw-footer-layout')) {
  customElements.define('lw-footer-layout', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const initialize = () => {
        if (!this.isConnected) return;
        const menus = [...this.querySelectorAll('[data-footer-menu]')];
        const desktop = window.matchMedia('(min-width: 1024px)');
        const update = () => menus.forEach(menu => {
          menu.open = desktop.matches;
          menu.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
        });
        desktop.addEventListener('change', update, {signal});
        menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
          if (desktop.matches) event.preventDefault();
        }, {signal}));
        this.addEventListener('shopify:block:select', event => {
          const menu = event.target.closest('[data-footer-menu]');
          if (menu) menu.open = true;
        }, {signal});
        // Keep native newsletter feedback visible after Shopify's form response.
        const signup = this.querySelector('[data-footer-signup]');
        if (signup && (signup.querySelector('.form-message--main') ||
          new URLSearchParams(location.search).get('form_type') === 'customer')) signup.open = true;
        update();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true, signal});
      else queueMicrotask(initialize);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
